import React from 'react';
import { convertIcon } from '../component/Icon';
interface OverrideIconSize24 {
  size: '24';
}
type OverrideIconSize = OverrideIconSize24;

const SvgComponent = ({
  size,
  color = '#616161',
  ...rest
}: React.SVGProps<SVGSVGElement> & OverrideIconSize) => {
  if (size === '24') {
    return (
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M15.3571 4L15.5235 4.00488C16.8418 4.08252 17.9078 5.07653 17.9943 6.33448L18 6.5V10.5H19.5C20.8255 10.5 21.91 11.5315 21.9947 12.8356L22 13V20.9706C22 21.5391 21.5391 22 20.9706 22C20.7673 22 20.5695 21.9398 20.4016 21.8285L20.3046 21.7555L19.0408 20.6833C18.8085 20.4862 18.5226 20.3653 18.2219 20.3348L18.0704 20.3271H11.5C10.1745 20.3271 9.08996 19.2956 9.00532 17.9915L9 17.8271V15.9149H6.12415L5.96556 15.9219C5.7135 15.9443 5.47089 16.0196 5.25651 16.1415L5.10132 16.2415L3.68143 17.2739L3.56744 17.3461C3.40988 17.4322 3.23148 17.4778 3.04963 17.4778C2.5155 17.4778 2.06407 17.0897 2.00625 16.5766L2 16.4648V6.5L2.00523 6.34104C2.08836 5.08218 3.15216 4.08612 4.46963 4.0053L4.64286 4H15.3571ZM19.5 11.5H11.5C10.7203 11.5 10.0796 12.0949 10.0069 12.8555L10 13V17.8271C10 18.6068 10.5949 19.2476 11.3555 19.3203L11.5 19.3271H18.0704C18.597 19.3271 19.1084 19.4934 19.5328 19.7995L19.6878 19.9208L20.9604 20.9982L20.9706 21C20.9814 21 20.9909 20.9941 20.996 20.9854L21 20.9706V13C21 12.2203 20.4051 11.5796 19.6445 11.5069L19.5 11.5ZM19 16.5C19 16.2239 18.7761 16 18.5 16H12.5C12.2239 16 12 16.2239 12 16.5C12 16.7761 12.2239 17 12.5 17H18.5C18.7761 17 19 16.7761 19 16.5ZM15.3571 5H4.64286L4.49222 5.0062C3.69904 5.07184 3.07708 5.65078 3.00665 6.36466L3 6.5V16.4648L3.02129 16.4742L3.04963 16.4778L3.07409 16.4743L3.09337 16.4651L4.51326 15.4327L4.69136 15.314C5.05663 15.0911 5.47423 14.9571 5.9068 14.9234L6.12415 14.9149H9V13C9 11.6745 10.0315 10.59 11.3356 10.5053L11.5 10.5H17V6.5L16.9934 6.36466C16.9229 5.65078 16.301 5.07184 15.5078 5.0062L15.3571 5ZM19 14.5C19 14.2239 18.7761 14 18.5 14H12.5C12.2239 14 12 14.2239 12 14.5C12 14.7761 12.2239 15 12.5 15H18.5C18.7761 15 19 14.7761 19 14.5Z"
          fill={color}
        />
      </svg>
    );
  }
  return <div></div>;
};
/**
 * 컬러 주입 가능여부: 가능,
 * 기본컬러:#616161
 * 사용가능한 사이즈는 24 입니다.
 * 20(디폴트)사이즈가 없으므로 size prop은 required 입니다.
 */
const IconComponent = convertIcon<OverrideIconSize>(SvgComponent, 'QnA');
export default IconComponent;
